import { render, staticRenderFns } from "./AssociatedProcesses.vue?vue&type=template&id=496b5102&scoped=true&"
import script from "./AssociatedProcesses.vue?vue&type=script&lang=ts&"
export * from "./AssociatedProcesses.vue?vue&type=script&lang=ts&"
import style0 from "./AssociatedProcesses.vue?vue&type=style&index=0&id=496b5102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496b5102",
  null
  
)

export default component.exports